import { useMemo } from 'react';
import { Marker } from 'react-map-gl';
import CustomMarker from './CustomMarker';
import { useSelector } from 'react-redux';
import useMarkers from '../../hooks/Markers';
import useMapActions from '../../hooks/MapActions';
import { ResultsType } from '../../types';

interface MarkersProps {
  mapRef: any;
}
const MapMarkers = ({ mapRef }: MarkersProps) => {
  const { selectCompound, selectArea } = useMapActions();
  const { config, resultsType } = useSelector((state: any) => state.map);
  const markersLocations = useMarkers({ mapRef });
  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );
  const firstDestination = useSelector(
    (state: any) => state.map.firstDestination
  );
  const secondDestination = useSelector(
    (state: any) => state.map.secondDestination
  );

  const mapMode = useSelector((state: any) => state.map.mapMode);

  const handleCompoundClick = (id: number) => {
    selectCompound(id);
  };
  const handleAreaClick = (id: number) => {
    selectArea(id);
  };

  const getClickZoom = () => {
    const currentZoom = mapRef.current.getZoom();
    if (
      currentZoom + 2 > config.desktop.areasMaxZoom &&
      resultsType === ResultsType.AREAS
    ) {
      return config.desktop.areasMaxZoom;
    }
    return mapRef.current.getZoom() + 2;
  };
  const handleClusterClick = (longitude: number, latitude: number) => {
    if (mapRef.current) {
      mapRef.current.flyTo({
        center: [longitude, latitude],
        zoom: getClickZoom(),
        essential: true
      });
    }
  };

  const Markers = useMemo(() => {
    if (markersLocations) {
      return markersLocations.map((location, index) => (
        <Marker
          key={`${location?.id}${index}`}
          longitude={location.longitude}
          latitude={location.latitude}
          onClick={e => {
            e.originalEvent.stopPropagation();
            e.originalEvent.stopImmediatePropagation();
            if (location.category === 'compound') {
              handleCompoundClick(location.id);
            } else if (location.category === 'area') {
              handleAreaClick(location.id);
            } else if (location.category === 'cluster') {
              handleClusterClick(location.longitude, location.latitude);
            }
          }}
          anchor="center"
          style={{
            cursor: 'pointer',
            zIndex: `${location.category === 'cluster' ? '1' : 'unset'}`
          }}
        >
          <CustomMarker
            id={location.id}
            name={location.name}
            type={location.type}
            category={location.category}
            index={index}
            clusterCount={location.cluster_count}
            isFiltered={location.isFiltered}
          />
        </Marker>
      ));
    }
  }, [
    markersLocations,
    selectedCompound,
    mapMode,
    firstDestination,
    secondDestination
  ]);

  return <>{Markers}</>;
};

export default MapMarkers;
